import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

const initialState = {
  content: null,
};

const conversionContentSlice = createSlice({
  name: "conversionContent",
  initialState,
  reducers: {
    setConversionContent(state, { payload }) {
      const { content } = payload;
      state.content = content;
    },
  },
});

export const { actions } = conversionContentSlice;
export default conversionContentSlice.reducer;

export const useConversionContentActions = () => {
  const dispatch = useDispatch();

  const setConversionContent = (content) => {
    dispatch(conversionContentSlice.actions.setConversionContent({ content }));
  };

  return {
    setConversionContent,
  };
};
